export const CreateCrossFilter = (crossFilters, selectedRows=[]) => {
  return crossFilters.map((item) => {
    if (item?.rows && item?.rows?.length > 0 && item.aggregate == 'Targeting') {
      return {
        aggregate: item.aggregate,
        ...(item.table_id !== '' && { table_id: item.table_id }),
        ...(item.column_name !== '' && { column_name: item.column_name }),
        ...(item.table_name != null && { table_name: item.table_name }),
        filters: item.rows.map((item) => {
          return {
            campaignId: item.campaignId,
            adGroupId: item.adGroupId,
            keywordId: item.keywordId,
            campaignName: item.campaignName,
            adGroupName: item.adGroupName,
            Targeting: item.Targeting,
            matchType: item.matchType,
            Type: item.Type
          };
        })
      };
    } else if (item?.rows && item?.rows?.length > 0 && window.location.href.includes('/amazon') && item.aggregate == 'SearchTerm') {
      return {
        aggregate: item.aggregate,
        ...(item.table_id !== '' && { table_id: item.table_id }),
        ...(item.column_name !== '' && { column_name: item.column_name }),
        ...(item.table_name != null && { table_name: item.table_name }),

        filters: item.rows.map((item) => {
          return {
            campaignName: item.campaignName,
            adGroupName: item.adGroupName,
            SearchTerm: item.SearchTerm,
            Type: item.Type
          };
        })
      };
    } else if (item?.rows && item?.rows?.length > 0 && item.aggregate == 'AdvertisedASINs') {
      return {
        aggregate: item.aggregate,
        ...(item.table_id !== '' && { table_id: item.table_id }),
        ...(item.column_name !== '' && { column_name: item.column_name }),
        ...(item.table_name != null && { table_name: item.table_name }),
        ...(item?.is_asin_parent == 1 && { is_asin_parent: 1 }),
        filters: item.rows.map((item) => {
          return {
            campaignId: item.campaignId,
            campaignName: item.campaignName,
            adGroupName: item.adGroupName,
            adGroupId: item.adGroupId,
            AdvertisedASINs: item.AdvertisedASINs,
            Type: item.Type
          };
        })
      };
    } else if (item?.rows && item?.rows?.length > 0 && item.aggregate == 'AudienceName') {
      return {
        aggregate: item.aggregate,
        ...(item?.table_id !== '' && { table_id: item.table_id }),
        ...(item?.column_name !== '' && { column_name: item.column_name }),
        ...(item?.table_name != null && { table_name: item.table_name }),
        filters: item.rows.map((item) => {
          return {
            campaignId: item.campaignId,
            campaignName: item.campaignName,
            adGroupName: item.campaignType === 'sponsored products' ? 'SPONSORED_PRODUCTS' : item.campaignType === 'sponsored brands' ? 'SPONSORED_BRANDS' : item.campaignType === 'sponsored display' ? 'SPONSORED_DISPLAY' : item.campaignType,
            audienceName: item.AudienceName
          };
        })
      }
    } 
    else if (item?.aggregate == 'AudienceName' && selectedRows?.length > 0) {
      return{
        aggregate: item.aggregate,
        filters: selectedRows?.map((item) =>{
          return{
            AudienceName: item?.AudienceName,
            profileId: item?.profileId
          }
        })
      }
    } else if (item?.rows && item?.rows?.length > 0 && window.location.href.includes('/flipkart') && item.aggregate == 'Campaigns') {
      return {
        aggregate: item.aggregate,
        ...(item?.table_id !== '' && { table_id: item.table_id }),
        ...(item?.column_name !== '' && { column_name: item.column_name }),
        ...(item?.table_name != null && { table_name: item.table_name }),
        filters: item.rows.map((item) => {
          return {
            Campaign: item.Campaign,
            CampaignId: item.CampaignId,
          };
        })
      }
    } else if (item?.rows && item?.rows?.length > 0 && window.location.href.includes('/flipkart') && item.aggregate == 'AdGroup') {
      return {
        aggregate: item.aggregate,
        ...(item?.table_id !== '' && { table_id: item.table_id }),
        ...(item?.column_name !== '' && { column_name: item.column_name }),
        ...(item?.table_name != null && { table_name: item.table_name }),
        filters: item.rows.map((item) => {
          return {
            Campaign: item.Campaign,
            CampaignId: item.CampaignId,
            AdGroup: item.AdGroup,
            AdGroupId: item.AdGroupId
          };
        })
      }
    } else if (item?.rows && item?.rows?.length > 0 && window.location.href.includes('/flipkart') && item.aggregate == 'Placement') {
      return {
        aggregate: item.aggregate,
        ...(item?.table_id !== '' && { table_id: item.table_id }),
        ...(item?.column_name !== '' && { column_name: item.column_name }),
        ...(item?.table_name != null && { table_name: item.table_name }),
        filters: item.rows.map((item) => {
          return {
            Campaign: item.Campaign,
            CampaignId: item.CampaignId,
            AdGroup: item.AdGroup,
            AdGroupId: item.AdGroupId,
            Placement: item?.Placement
          };
        })
      }
    } else if (item?.rows && item?.rows?.length > 0 && window.location.href.includes('/flipkart') && item.aggregate == 'FsnId') {
      return {
        aggregate: item.aggregate,
        ...(item?.table_id !== '' && { table_id: item.table_id }),
        ...(item?.column_name !== '' && { column_name: item.column_name }),
        ...(item?.table_name != null && { table_name: item.table_name }),
        filters: item.rows.map((item) => {
          return {
            Campaign: item.campaign_name,
            CampaignId: item.campaign_id,
            AdGroup: item.adgroup_name,
            AdGroupId: item.adgroup_id,
            FsnId: item.FsnId,
            BannerId: item.banner_id,
          };
        })
      }
    } else if (item?.rows && item?.rows?.length > 0 && window.location.href.includes('/flipkart') && item.aggregate == 'SearchTerm') {
      return {
        aggregate: item.aggregate,
        ...(item?.table_id !== '' && { table_id: item.table_id }),
        ...(item?.column_name !== '' && { column_name: item.column_name }),
        ...(item?.table_name != null && { table_name: item.table_name }),
        filters: item.rows.map((item) => {
          return {
            Campaign: item.campaign_name,
            CampaignId: item.campaign_id,
            AdGroup: item.adgroup_name,
            AdGroupId: item.adgroup_id,
            SearchTerm: item.SearchTerm,
          };
        })
      }
    }

    return {
        aggregate: item.aggregate,
        ...(item?.table_id !== '' && { table_id: item.table_id }),
        ...(item?.column_name !== '' && { column_name: item.column_name }),
        ...(item?.table_name != null && { table_name: item.table_name }),
        ...(item?.is_asin_parent == 1 && { is_asin_parent: 1 }),
        filters: item.filters
    };
  });
};

export const createRowInfo = (aggregate, rowInfo) => {
  if(aggregate == 'Targeting') {
    return {
      campaignId: rowInfo?.campaignId,
      adGroupId: rowInfo?.adGroupId,
      keywordId: rowInfo?.keywordId,
      campaignName: rowInfo?.campaignName,
      adGroupName: rowInfo?.adGroupName,
      Targeting: rowInfo?.Targeting,
      matchType: rowInfo?.matchType,
      Type: rowInfo?.Type
    }
  }
  if(aggregate == 'SearchTerm') {
    return {
      campaignName: rowInfo?.campaignName,
      adGroupName: rowInfo?.adGroupName,
      SearchTerm: rowInfo?.SearchTerm,
      Type: rowInfo?.Type
    }
  }
  if(aggregate == 'AdvertisedASINs') {
    return {
      campaignId: rowInfo?.campaignId,
      campaignName: rowInfo?.campaignName,
      adGroupName: rowInfo?.adGroupName,
      adGroupId: rowInfo?.adGroupId,
      AdvertisedASINs: rowInfo?.AdvertisedASINs,
      Type: rowInfo?.Type
    }
  }
  return {}
}
